import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';
import validationEngine from 'devextreme/ui/validation_engine';

@Component({
    selector: 'app-material-dialog',
    templateUrl: './material-dialog.component.html',
    styleUrls: ['./material-dialog.component.scss'],
    standalone: false
})
export class MaterialDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    jobMaterial: any;
    jobId: number;
    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';

    constructor(
        public modalRef: BsModalRef,
        private uow: RAFUnitOfWork,
        private appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        this.jobMaterial = this.uow.jobMaterials.createEntity(); 
        this.jobMaterial.jobId = this.jobId;
    }

    async save() {
        const success = await Promise.resolve(this.validate());
        if (!success) return;

        this.result.next({ success: true });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }

        return true;
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }
}
